<div class="mainContainer">
  <div class="logoContainer">
    <div
      class="ImageContainer"
      [ngClass]="{
        'default-logo': this.ImageURL == null || this.ImageURL.trim() == ''
      }"
    >
      <img
        *ngIf="!(this.ImageURL == null || this.ImageURL.trim() == '')"
        [src]="ImageURL"
        alt="Logo"
        class="inner-image"
      />
    </div>
    <div class="divider"></div>
    <div class="study-name-area">
      <!-- Show clickable dropdown when multiple studies exist and module is CrossTab or Brand Analysis -->
      <div class="study-header-name" (click)="studyDropdown()" *ngIf="shouldShowDropdown">
        <div class="study-block">
          {{displayStudyName }}
        </div>
        <div class="study-open-icon">
        </div>
      </div>

      <!-- Show plain text when only one study exists or module is not CrossTab/Brand Analysis -->
      <div class="study-header-name" *ngIf="!shouldShowDropdown">
        <div class="study-block">
          {{displayStudyName }}
        </div>
      </div>

      <div class="StudyListArea" *ngIf="showStudyDropdown && shouldShowDropdown" id="study-dropdown">
        <div class="studyDropdown" *ngFor="let study of configuredStudies">
            <div class="studyDropdown_Container" (click)="navigateStudy(study?.StudyName)">
              <div class="studyDropdown_Container_Name" [class.selected_Text]="study?.StudyName === studyName">{{ study?.UIStudyName?.trim() ? study.UIStudyName : study?.StudyName }}</div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
